import { PublicPage } from '../base.js';
import { AppConfig } from '../../config.js';

export class ResendConfirmation extends PublicPage {
  static timl = `
    section.auth-page[aria-labelledby="resend-confirmation-title"]
      form.stacked-form.auth-form[action="${AppConfig.authServiceApiBaseUrl}/en/1/resend-email-verification" handler="ResendConfirmation.resendHandler" method="POST"]
        header.auth-header
          h1#resend-confirmation-title Resend confirmation
          p#resend-confirmation-message Enter your email address and we'll send you a new confirmation link.
        .auth-fields#resend-confirmation-field
          label.auth-field
            span Email address
            input[name="email" type="email" autocomplete="email" placeholder="you@example.com" required="true"]
        .auth-submit-row#resend-confirmation-actions
          button.auth-primary[type="submit"] Resend email
        .auth-followup#resend-confirmation-followup[style="display:none;"]
          a.auth-primary.auth-primary-link[href="/confirm-email"] Enter confirmation code
          p.auth-muted-link
            span Ready to continue?
            a[href="/login"] Go to login
        .auth-divider#resend-confirmation-divider[aria-hidden="true"]
          span or
        p.auth-switch#resend-confirmation-switch
          span Already confirmed?
          a[href="/login"] Log in
  `;

  static resendHandler(form, data) {
    if (!data.success) return;

    const titleEl = document.querySelector('#resend-confirmation-title');
    const messageEl = document.querySelector('#resend-confirmation-message');
    const fieldEl = document.querySelector('#resend-confirmation-field');
    const actionsEl = document.querySelector('#resend-confirmation-actions');
    const followupEl = document.querySelector('#resend-confirmation-followup');
    const dividerEl = document.querySelector('#resend-confirmation-divider');
    const switchEl = document.querySelector('#resend-confirmation-switch');

    if (titleEl) titleEl.innerText = 'Email Sent';
    if (messageEl) {
      messageEl.innerText = 'A new confirmation email has been sent. Please check your inbox, or enter the confirmation code manually if the link in your email does not work.';
    }
    if (fieldEl) fieldEl.style.display = 'none';
    if (actionsEl) actionsEl.style.display = 'none';
    if (followupEl) followupEl.style.display = 'flex';
    if (dividerEl) dividerEl.style.display = 'none';
    if (switchEl) switchEl.style.display = 'none';
  }
}

globalThis.ResendConfirmation = ResendConfirmation;
